import type React from 'react';
import { DISCOUNT_SCOPE, useShortcutScope } from '@/components/shortcuts';

/**
 * Pushed only while the discount dialog is open, suspending the rest of the
 * `seller` scope so no sale-screen shortcut fires underneath it — mirrors
 * `PaymentScope`. A named sibling of `DiscountDialog.tsx` rather than a second
 * component in that file (rulebook §5.2).
 */
export const DiscountDialogScope: React.FC = () => {
    useShortcutScope(DISCOUNT_SCOPE);
    return null;
};
